import _ from 'lodash'
import axios from 'axios'

export default {

// eslint-disable-next-line no-unused-vars
  install(Vue, options) {

    Vue.prototype.$isLoggedIn = function () {
      var userData = Vue.ls.get('userData');
      return userData !== null;      
    }
    Vue.prototype.$loggedUser = function () {
      var userData = Vue.ls.get('userData');
      return userData;      
    }



    Vue.prototype.$addUserTalk = function (talk) {
      var theTalks = Vue.ls.get('selectedTalks');


      if (theTalks === undefined || theTalks === null) {
        theTalks = [];
      }

      if (!_.find(theTalks, {id: talk.id})) {
        theTalks.push(talk);
      }

      Vue.ls.set('selectedTalks', theTalks);


      var newTalks = Vue.ls.get('newTalks') || 0;
      Vue.ls.set('newTalks', ++newTalks);


      this.$toast.open('Evento adicionado a sua agenda!');

      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'Agenda',
        action: 'add',
        label: talk.start_date +'||'+talk.track.slug+'||'+talk.title,
        value: 5000,
        noninteraction: false // Optional
      });


    }


    Vue.prototype.$removeUserTalk = function (talkId) {
      var theTalks = Vue.ls.get('selectedTalks');

      var talk = {};

      if (theTalks === undefined || theTalks === null) {
        theTalks = [];
      }

      _.remove(theTalks, function(talkRemove){
        if (talkRemove.id == talkId) {
          talk = talkRemove;
          return true;
        }
      });

      Vue.ls.set('selectedTalks', theTalks);

      this.$toast.error('Evento removido da sua agenda!');

      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'Agenda',
        action: 'delete',
        label: talk.start_date +'||'+talk.track.slug+'||'+talk.title,
        value: 5000,
        noninteraction: false // Optional
      });


    }

    Vue.prototype.$getUserTalks = function () {
      var theTalks = Vue.ls.get('selectedTalks');

      if (theTalks === undefined || theTalks === null) {
        theTalks = [];
      }

      return theTalks;

    }


    Vue.prototype.$userHaveTalk = function (talk) {
      var theTalks = Vue.ls.get('selectedTalks');

      return _.find(theTalks, {id: talk.id});
    }


    Vue.prototype.$getTalks = async function() {
      var theTalks = [];


      return new Promise((resolve, reject) => {

        axios.all([
            axios.get(process.env.VUE_APP_ENDPOINT+"/talks?token="+process.env.VUE_APP_TOKEN),
            axios.get(process.env.VUE_APP_ENDPOINT+"/talks_complementares?token="+process.env.VUE_APP_TOKEN),
            axios.get(process.env.VUE_APP_ENDPOINT+"/talks_oferecimento?token="+process.env.VUE_APP_TOKEN)
        ]).then(axios.spread(function (response1, response2, response3) {

          theTalks = response1.data.talks.concat(response2.data.talks,response3.data.talks);
          console.log(theTalks);

          resolve(theTalks);
        }))
        .catch(function (error) {
          console.log(error, reject);
        });

      });


    }

    Vue.prototype.$getPalcos = function () {
      var theTalks = [];
      var thePalcos = [];

      return new Promise((resolve, reject) => {

        axios.all([
            axios.get(process.env.VUE_APP_ENDPOINT+"/talks?token="+process.env.VUE_APP_TOKEN),
            axios.get(process.env.VUE_APP_ENDPOINT+"/talks_complementares?token="+process.env.VUE_APP_TOKEN),
            axios.get(process.env.VUE_APP_ENDPOINT+"/talks_oferecimento?token="+process.env.VUE_APP_TOKEN)
        ]).then(axios.spread(function (response1, response2, response3) {

          let responses = {
            'principal': response1, 
            'complementar': response2, 
            'patrocinador': response3
          };


          for (const tipo in responses) {
            theTalks = responses[tipo].data;

            var i = 0;
            theTalks.talks.forEach((talk)=> {

              let palco = {
                id: talk.trackSlug,
                title: talk.track,
                metas: talk.trackMetas,
                order: ++i,
                checked: false,
                type: tipo
              }

              if (palco.id !== null && !_.find(thePalcos, {id: palco.id})) {
                thePalcos.push(palco);
              }

            });
          }

          resolve(thePalcos);

        }))
        .catch(function (error) {
          console.log(error, reject);
        });

      });

    }

    Vue.prototype.$downloadIcs = function() {

      var talks = this.$getUserTalks();

      talks.map((talk)=>{
        var description = "";
        talk.speakers.map((speaker) => {
          description += speaker.name+" ("+speaker.job_title+" - "+speaker.company+")\n";
        });
        this.$ics.addEvent('pt-br', talk.title, description, talk.track+' - Fórum E-Commerce Brasil 2022', talk.date_start, talk.date_end, 'https://eventos2.ecommercebrasil.com.br/forum/', 'E-Commerce Brasil');
      });

      this.$ics.download("MinhaAgenda-Forum-ECBR-2022.ics");

      this.$ics.removeAllEvents();


    }




  }
}
